import React, { Component } from "react";
import {
  Row,
  Col,
  FormInput,
  FormGroup,
  FormSelect,
} from "shards-react";

import { connect } from "react-redux";
import { getAllTitles } from "../../../actions/other_info/title.action";
import { getAllPositions } from "../../../actions/other_info/position.action";
import { getAllUserRole } from "../../../actions/user.action";

class UserFrom extends Component {
  constructor(props) {
    super(props);

    this.state = {
      roles: [],
      titles: [],
      positions: []
    };
  }

  async componentDidMount() {
    await this.props.getAllUserRole();
    if (this.props.userReducer.roles) {
      this.setState({ roles: this.props.userReducer.roles });
    }

    await this.props.getAllTitles();
    if(this.props.titlesReducer.titles) {
        this.setState({ titles: this.props.titlesReducer.titles })
    }

    await this.props.getAllPositions();
    if(this.props.positionsReducer.positions){
        this.setState({ positions:this.props.positionsReducer.positions })
    }
  }

  render() {
    const { values, handleChange, isDisableField, handleBlur } = this.props;

    return (
      <React.Fragment>
        <fieldset disabled={isDisableField}>
          {/* <Row form>
            <Col md="6" className="form-group">
              <label>Position</label>
              <FormSelect
                  name="user_position"
                  id="user_position"
                  onChange={handleChange}
                  value={values.user_position}
                >
                  <option value=""></option>
                  {this.state.positions.map((position) => {
                    return (
                      <option value={position.name}>{position.name}</option>
                    );
                  })}
                </FormSelect>
            </Col>
            <Col md="6">
              <label>Title</label>
              <FormSelect
                  name="user_title"
                  id="user_title"
                  onChange={handleChange}
                  value={values.user_title}
                >
                  <option value=""></option>
                  {this.state.titles.map((title) => {
                    return (
                      <option value={title.thai_title}>{title.thai_title}</option>
                    );
                  })}
                </FormSelect>
            </Col>
          </Row> */}
          <Row form>
            <Col md="6" className="form-group">
              <label>ชื่อในระบบ</label>
              <FormInput
                name="displayName"
                id="displayName"
                onChange={handleChange}
                value={values.displayName}
              />
            </Col>
            <Col md="6" className="form-group">
              <FormGroup>
                <label>Email</label>
                <FormInput
                  name="user_email"
                  id="user_email"
                  placeholder="Email"
                  onChange={handleChange}
                  value={values.microsoftAccount}
                  disabled={true}
                />
              </FormGroup>
            </Col>
          </Row>

          <Row form>
            <Col md="6" className="form-group">
              <label>ชื่อ</label>
              <FormInput
                name="givenName"
                id="givenName"
                onChange={handleChange}
                value={values.givenName}
              />
            </Col>
            <Col md="6">
              <label>นามสกุล</label>
              <FormInput
                name="surname"
                id="surname"
                onChange={handleChange}
                value={values.surname}
              />
            </Col>
          </Row>

          {/* <Row form>
            <Col md="6" className="form-group">
              <FormGroup>
                <label>User Role</label>
                <FormSelect
                  name="user_role"
                  id="user_role"
                  onChange={handleChange}
                  value={values.user_role}
                >
                  {this.state.roles.map(role => {
                    return (
                      <option value={role.role_id}>{role.role_name}</option>
                    );
                  })}
                </FormSelect>
              </FormGroup>
            </Col>
          </Row> */}
        </fieldset>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ userReducer, titlesReducer,positionsReducer }) => ({
  userReducer,
  titlesReducer,
  positionsReducer
});

const mapDispatchToProps = {
    getAllTitles,
    getAllUserRole,
    getAllPositions
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserFrom);
